// extracted by mini-css-extract-plugin
module.exports = {"selector":"MobileSelect_selector__fGqAB","selectorHidden":"MobileSelect_selectorHidden__Rz8y3"};